import backArrow from '../../assets/img/backArrow.png';
import { useState, useRef, useEffect, useContext } from 'react';
import { Spin, message } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import './EmailInput.css';
import api from 'api';
import { get } from 'utils/fetch';
import PdfIcon from '../../assets/img/PdfIcon.png';
import { FaPaperclip } from 'react-icons/fa';
import { getMimeType, getFileIcon } from 'utils/util';
import { formatCurrency, USDollar } from 'utils/format';
import { GlobalContext } from 'GlobalContext';
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';

export function NoticeEmail(props) {
    const { setEmailResponse, transactionId, transactionType, resetState } =
        props;
    const { accessToken, refreshSession } = useContext(GlobalContext);
    const [messageApi, contextHolder] = message.useMessage();
    const [emails, setEmails] = useState([]);
    const [inputEmail, setInputEmail] = useState('');
    const [subject, setSubject] = useState('');
    const textAreaRef = useRef(null);
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);
    const [files, setFiles] = useState([]);
    const [fundName, setFundName] = useState('');
    const [investmentAmount, setInvestmentAmount] = useState(0);
    const [transactionAmount, setTransactionAmount] = useState(0);
    const [investorNames, setInvestorNames] = useState([]);
    const [transactionDetail, setTransactionDetail] = useState(null);
    const [accountName, setAccountName] = useState('');
    const [investmentStartingDate, setInvestmentStartingDate] = useState('');
    const [investmentId, setInvestmentId] = useState(-1);
    const [currency, setCurrency] = useState(null);

    const displayErrorMessage = (message) => {
        messageApi.open({
            type: 'error',
            content: message,
        });
    };

    // console.log(content)

    async function fetchSubjectTemplate() {
        await get(
            api.email.subjectTemplate,
            setSubject,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchPdf() {
        // Fetch the PDF from the FastAPI backend
        fetch(api.email.pdfTemplate, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/pdf',
                Authorization: `Bearer ${accessToken}`,
            },
        })
            .then((response) => {
                // Get filename from Content-Disposition header
                const contentDisposition = response.headers.get(
                    'Content-Disposition'
                );
                // console.log(contentDisposition)
                const matches =
                    contentDisposition &&
                    contentDisposition.match(/filename=(.+)/);
                // console.log(contentDisposition.match(/filename=(.+)/))
                const filename = matches ? matches[1] : 'default.pdf'; // Fallback if no filename
                return response.blob().then((blob) => {
                    const url = URL.createObjectURL(blob);
                    setFiles([...files, { filename, url, blob }]);
                });
            })
            .catch((err) => console.error('Error fetching PDF:', err));
    }

    async function fetchContentTemplate() {
        await get(
            api.email.contentTemplate,
            setContent,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        setLoading(false);
    }

    async function fetchFundNameByTransactionId(id) {
        await get(
            api.email.fundNameByTransactionId(id),
            setFundName,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchEmailsByTransactionId(id) {
        await get(
            api.email.emailsByTransactionId(id),
            setEmails,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchTransactionDetails(id) {
        await get(
            api.email.transactionDetailsByTransactionId(id),
            setTransactionDetail,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchInvestmentIdByTransactionId(id) {
        await get(
            api.email.investmentIdByTransactionId(id),
            setInvestmentId,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    // console.log(investmentId)
    async function fetchTransactionAmount(id) {
        await get(
            api.email.transactionAmount(id),
            setTransactionAmount,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchAccountNameByTransactionId(id) {
        await get(
            api.email.accountNameByTransactionId(id),
            setAccountName,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchInvestmentStartingDate(id) {
        await get(
            api.email.investmentStartingDate(id),
            setInvestmentStartingDate,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function setNoticeSubject() {
        await get(
            api.email.getNoticeSubjectLine(transactionId),
            setSubject,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    function setNoticeContent() {
        setContent(`Dear Investor,

We are pleased to inform you that we have already distributed the ${formatCurrency(
            transactionAmount,
            currency
        )} interest for the ${fundName} Project. Please note that due to banking processing times, the interest payment may take 1-2 business days to appear in your account. Kindly monitor your bank account for confirmation. If you have any inquiries or require further assistance, please do not hesitate to reach out to us.

Thank you for your invaluable trust and partnership.

Warm regards,
AlphaX RE Capital
`);
    }

    // console.log(fundName)
    // console.log(investmentAmount)
    // console.log(investorNames)
    // console.log(investmentStartingDate)
    async function fetchNoticePdf() {
        const body = JSON.stringify({
            fundName,
            transactionAmount: formatCurrency(transactionAmount, currency),
            accountName,
            transactionId,
        });
        // Fetch the PDF from the FastAPI backend
        fetch(api.email.noticePdf, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/pdf',
                Authorization: `Bearer ${accessToken}`,
            },
            body,
        })
            .then((response) => {
                // Get filename from Content-Disposition header
                const contentDisposition = response.headers.get(
                    'Content-Disposition'
                );
                // console.log(contentDisposition)
                const matches =
                    contentDisposition &&
                    contentDisposition.match(/filename="(.+)"/);
                // console.log(contentDisposition.match(/filename=(.+)/))
                const filename = matches ? matches[1] : 'default.pdf'; // Fallback if no filename
                return response.blob().then((blob) => {
                    const url = URL.createObjectURL(blob);
                    setFiles([...files, { filename, url, blob }]);
                });
            })
            .then(() => setLoading(false))
            .catch((err) => console.error('Error fetching PDF:', err));
    }

    useEffect(() => {
        // set up receipt text
        // console.log("fundName", fundName)
        // console.log("investmentAmount", investmentAmount)
        // console.log("investorNames", investorNames)
        // console.log("investmentStartingDate", investmentStartingDate)
        if (
            fundName &&
            accountName &&
            transactionAmount !== undefined &&
            transactionAmount !== null
        ) {
            setNoticeSubject();
            setNoticeContent(); // Only set content when all the necessary data is loaded
            fetchNoticePdf();
        }
    }, [fundName, accountName, transactionAmount]); // Watch for changes to these values
    // console.log(transactionDetail);

    useEffect(() => {
        restore();
    }, [transactionDetail]);

    function restore() {
        if (!transactionDetail) return;
        setInvestmentId(transactionDetail.investment_id);
        setTransactionAmount(transactionDetail.amount);
        setAccountName(transactionDetail.account_name);
        setFundName(transactionDetail.name);
        setCurrency(transactionDetail.currency);
    }

    async function setUp() {
        // need to get fund name, investor name, invested amount
        // fetchFundNameByTransactionId(transactionId);
        // fetchAccountNameByTransactionId(transactionId);
        // fetchTransactionAmount(transactionId);
        // fetchInvestmentIdByTransactionId(transactionId);
        fetchTransactionDetails(transactionId);
        fetchEmailsByTransactionId(transactionId);
    }

    useEffect(() => {
        if (accessToken === '') return;
        // set up subject, content, file
        setUp();
    }, [accessToken]);

    // Handle input change
    const handleInputChange = (e) => {
        setInputEmail(e.target.value);
    };

    // Handle key down (when pressing "Enter")
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && inputEmail.trim() !== '') {
            // Basic email validation
            if (validateEmail(inputEmail.trim())) {
                setEmails([...emails, inputEmail.trim()]);
                setInputEmail(''); // Clear input after adding email
            } else {
                alert('Please enter a valid email address');
            }
            e.preventDefault();
        }
    };

    // Validate email using a basic regex
    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    // Remove email from the list
    const removeEmail = (index) => {
        setEmails(emails.filter((_, i) => i !== index));
    };

    useEffect(() => {
        // Adjust the height based on the scroll height
        if (textAreaRef.current) {
            textAreaRef.current.style.height = 'auto'; // Reset height to auto
            textAreaRef.current.style.height =
                textAreaRef.current.scrollHeight + 'px'; // Set to scroll height
        }
    }, [content]); // Re-run whenever the content changes
    // console.log(transactionId, transactionType)
    async function sendEmail() {
        if (emails.length === 0) {
            alert('Please add recipients');
            return;
        }
        setEmailResponse('Sending...');

        // Create a FormData object
        const formData = new FormData();
        // formData.append('files', files.map(file => new File([file.blob], file.filename, { type: 'application/pdf' })))
        files.map((file) =>
            formData.append(
                'files',
                new File([file.blob], file.filename, {
                    type: getMimeType(file.filename),
                })
            )
        );
        // formData.append('to_email', emails);  // Append the recipient's email
        emails.map((email) => formData.append('to_emails', email.trim()));
        formData.append('subject', subject); // Append the email subject
        formData.append('content', content.replace(/\n/g, '<br>\n')); // Append the email content
        formData.append('investment_id', investmentId);
        formData.append('purpose', 'notice');

        resetState();

        // Send the email with the PDF attachment
        const emailResponse = await fetch(api.email.sendEmail, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
            body: formData,
        });

        const emailResult = await emailResponse.json();
        setEmailResponse(emailResult.message);
        // Hide the message after 1 second
        setTimeout(() => {
            setEmailResponse('');
        }, 1000);
        // console.log(emailResult);
    }
    // console.log(content)
    // console.log(content.replace(/\n/g, '<br>\n'))
    const handleFileChange = (e) => {
        const file = e.target.files[0]; // Get the first selected file
        if (file) {
            // Generate a temporary URL for the file
            const tempUrl = URL.createObjectURL(file);
            setFiles([
                ...files,
                {
                    filename: e.target.files[0].name,
                    url: tempUrl,
                    blob: e.target.files[0],
                },
            ]); // Allow multiple files to be uploaded
        }
    };

    const triggerFileInput = () => {
        document.getElementById('fileInput').click(); // Trigger file input click
    };

    return (
        <>
            <div
                style={{
                    position: 'fixed',
                    top: '20px',
                    right: '20px',
                    backgroundColor: 'transparent',
                    padding: '20px',
                    borderRadius: '10px',
                    zIndex: 3,
                }}
                onClick={() => resetState()}
            >
                <CloseOutlined style={{ fontSize: '40px' }} />
                {/* Your content goes here */}
            </div>
            {loading && (
                <div
                    style={{
                        position: 'fixed',
                        width: '100vw',
                        height: '100vh',
                        top: 0,
                        left: 0,
                        background: 'white',
                        zIndex: 1,
                    }}
                >
                    <Spin
                        style={{
                            position: 'absolute',
                            top: '30%',
                            left: '50%',
                        }}
                    />
                </div>
            )}
            {!loading && (
                <div
                    style={{
                        position: 'fixed',
                        width: '100vw',
                        height: '100vh',
                        top: 0,
                        left: 0,
                        background: 'white',
                        zIndex: 1,
                        overflowY: 'auto',
                    }}
                >
                    <div style={{ marginTop: '100px', padding: '0 20px' }}>
                        <div
                            className="email-input-container"
                            style={{ width: '100%' }}
                        >
                            <div className="emails" style={{ width: '100%' }}>
                                {emails.map((email, index) => (
                                    <div key={index} className="email-chip">
                                        {email}
                                        <span
                                            className="remove-btn"
                                            onClick={() => removeEmail(index)}
                                        >
                                            &times;
                                        </span>
                                    </div>
                                ))}
                                <input
                                    type="text"
                                    value={inputEmail}
                                    onChange={handleInputChange}
                                    onKeyDown={handleKeyDown}
                                    placeholder="Enter email addresses"
                                    className="email-input"
                                    style={{
                                        width: `${Math.max(
                                            20,
                                            inputEmail.length * 10
                                        )}px`,
                                    }} // Dynamically resize input
                                />
                            </div>
                        </div>

                        <div
                            className="email-input-container"
                            style={{ width: '100%' }}
                        >
                            <div className="emails" style={{ width: '100%' }}>
                                <input
                                    type="text"
                                    value={subject}
                                    onChange={(e) => setSubject(e.target.value)}
                                    // onKeyDown={handleKeyDown}
                                    placeholder="Subject..."
                                    className="email-input"
                                    style={{ width: `100%` }} // Dynamically resize input
                                />
                            </div>
                        </div>

                        <div
                            className="email-input-container"
                            style={{ width: '100%' }}
                        >
                            <div className="emails" style={{ width: '100%' }}>
                                <textarea
                                    type="text"
                                    ref={textAreaRef}
                                    value={content}
                                    onChange={(e) => setContent(e.target.value)}
                                    // onKeyDown={handleKeyDown}
                                    placeholder="Content..."
                                    className="email-input"
                                    style={{
                                        width: `100%`,
                                        minHeight: '500px',
                                        fontFamily: 'Arial, sans-serif',
                                    }} // Dynamically resize input
                                />
                                {/* <ReactQuill
                                    value={content}
                                    onChange={setContent}
                                    modules={{
                                        toolbar: [
                                            [
                                                'bold',
                                                'italic',
                                                'underline',
                                                { list: 'bullet' },
                                            ],
                                            // [{ list: 'bullet' }],
                                            // ['link'],
                                        ],
                                    }}
                                    style={{
                                        height: '500px',
                                        marginBottom: '2rem',
                                    }}
                                /> */}

                                {/* Hidden preview or send logic */}
                                {/* <div style={{ display: 'none' }}>{content}</div> */}
                            </div>
                        </div>
                    </div>

                    {files && (
                        <div style={{ padding: '0 20px' }}>
                            {files.map((file, idx) => (
                                <div
                                    key={idx}
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                    }}
                                >
                                    <a
                                        href={file.url}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        {/* <iframe src={pdfUrl} width="100%" height="600px" title="PDF Preview" /> */}
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                fontSize: '15px',
                                                color: 'black',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    padding: '5px',
                                                    paddingBottom: '0',
                                                    fontSize: '20px',
                                                }}
                                            >
                                                {getFileIcon(file.filename)}
                                                {/* <img src={PdfIcon} style={{ width: "14px" }}></img> */}
                                            </div>
                                            {file.filename}
                                        </div>
                                    </a>
                                    <span
                                        style={{
                                            marginLeft: '10px',
                                            alignContent: 'center',
                                            fontWeight: 'bold',
                                            color: '#FF0000',
                                            fontSize: '15px',
                                            cursor: 'pointer',
                                        }}
                                        className="remove-btn"
                                        onClick={() =>
                                            setFiles(
                                                files.filter(
                                                    (_, i) => i !== idx
                                                )
                                            )
                                        }
                                    >
                                        &times;
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}

                    <div style={{ display: 'flex', padding: '0 20px' }}>
                        <button
                            style={{
                                height: '30px',
                                width: '50px',
                                borderRadius: '30px',
                                background: 'rgb(17 32 86)',
                                color: 'white',
                                cursor: 'pointer',
                            }}
                            onClick={sendEmail}
                        >
                            Send
                        </button>

                        <div
                            style={{ alignSelf: 'center', marginLeft: '10px' }}
                        >
                            <FaPaperclip
                                style={{
                                    cursor: 'pointer',
                                    fontSize: '24px',
                                    color: '#4A90E2',
                                }}
                                onClick={triggerFileInput}
                            />
                        </div>
                    </div>

                    {/* Hidden file input */}
                    <input
                        id="fileInput"
                        type="file"
                        multiple
                        onChange={handleFileChange}
                        style={{ display: 'none' }} // Hide the default file input
                    />
                </div>
            )}
        </>
    );
}
